module.exports = __webpack_public_path__ + "img/k02.2cb84a14.png";